export default {
    bloglist: {
        en: [
            {
                title: 'Setting Up GBWhatsApp for Maximum Efficiency',
                poster: require('@/assets/blog-1-1.webp'),
                desc: "A simple, human guide to setting up GBWhatsApp right — faster chats, better privacy, and a look that actually feels like yours.",
                name: 'en-blog-1',
                url: 'https://gbwhataps.com/setup-gbwhatsapp-guide/',
                date:"2025-10-20",
            },
            {
                title: 'The Secret Settings That Make GBWhatsApp More Private Than Ever',
                poster: require('@/assets/blog-2.webp'),
                desc: "Unlock hidden GBWhatsApp settings that enhance privacy, hide activity, and let you control who sees your chats and status.",
                name: 'en-blog-2',
                url: 'https://gbwhataps.com/the-secret-settings-that-make-gbwhatsapp-more-private-than-ever/',
                date:"2025-10-20",
            },
            {
                title: 'How to Lock Conversations in GBWhatsApp Without Interrupting Chat Flow',
                poster: require('@/assets/blog-3-1.webp'),
                desc: "Learn how to secure your GBWhatsApp chats with the lock conversation feature while keeping messaging smooth and uninterrupted.",
                name: 'en-blog-3',
                url: 'https://gbwhataps.com/how-to-lock-conversations-in-gbwhatsapp-without-interrupting-chat-flow/',
                date:"2025-10-27",
            },
            {
                title: 'How to Hide Online Status in GBWhatsApp',
                poster: require('@/assets/blog-4-1.webp'),
                desc: "In order to better protect personal privacy, GB WhatsApp lets you easily hide your online status without affecting your daily communication experience.",
                name: 'en-blog-4',
                url: 'https://gbwhataps.com/hide-online-status-in-gbwhatsapp/',
                date:"2025-11-06",
            },
            {
                title: 'How to Change Themes in GBWhatsApp',
                poster: require('@/assets/blog-5.webp'),
                desc: "Learn how to change and customize GBWhatsApp themes with step-by-step instructions. Discover theme installation methods, customization options, and troubleshooting tips.",
                name: 'en-blog-5',
                url: 'https://gbwhataps.com/change-themes-gbwhatsapp/',
                date:"2025-11-20",
            },
            {
                title: 'GB WhatsApp Not Installing? How to Fix "App Not Installed"',
                poster: require('@/assets/how-to-fix-gbwhatsapp-not-installing.webp'),
                desc: "If you can't install GB WhatsApp, you can read the methods we provide to fix these bugs.",
                name: 'en-blog-6',
                url: '/how-to-fix-gbwhatsapp-not-installing/',
                date:"2026-09-09",
            },
            {
                title: 'How to Save GB WhatsApp Status Photos and Videos',
                poster: require('@/assets/save-gb-whatsapp-status.webp'),
                desc: 'Learn how to save GB WhatsApp Status photos and videos, find downloaded files on Android, and fix common saving problems.',
                name: 'en-blog-7',
                url: '/save-gb-whatsapp-status/',
                date: '2026-10-23',
            },
            {
                title: 'How to Hide Typing and Recording Status in GB WhatsApp',
                poster: require('@/assets/hide-typing-recording-status.webp'),
                desc: 'Learn how to hide typing and recording indicators in GB WhatsApp, find the relevant privacy settings, and troubleshoot common issues.',
                name: 'en-blog-8',
                url: '/hide-typing-recording-status-gb-whatsapp/',
                date: '2026-10-23',
            },
            // {
            //     title: 'How to Change Fonts on GBWhatsApp Easily',
            //     poster: require('@/assets/blog-1.webp'),
            //     desc: "GBWhatsApp is one of the most popular WhatsApp mods in 2025, loved for its extra features and customization options. Among its most sought-after features is the ability to change fonts in GBWhatsApp — giving your chats a fresh, stylish look.",
            //     name: 'en-blog1',
            //     url: 'https://gbwhataps.com/how-change-fonts-on-gbwhatsapp/',
            //     date:"2025-08-15",
            // }
        ],
    }
    
}
